export default "__VITE_ASSET__4f2fe383__"